import * as React from "react";
import { useState } from "react";
import { useLogin, useNotify, Notification, defaultTheme } from "react-admin";
import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { generateOtp } from "./auth-provider/ra-auth-jwt"
import "./login.scss";

const CLASS_NAME = "login-page";

const Login = ({ theme }: any) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const login = useLogin();
  const notify = useNotify();

  const submit = (e: any) => {
    console.log('submit');
    e.preventDefault();
    login({ username, password })
      .catch((e) => {
        if (e === "NotRegistered")
          notify("کاربر وجود ندارد!", { type: 'error' })
        else if (e === "Incorrect")
          notify("نام کاربری یا پسورد اشتباه است", { type: 'error' })
        else
          notify("خطا در ورود", { type: 'error' })
      }
      );
  }

  return (
    <ThemeProvider theme={createTheme(defaultTheme)}>
      <div className={`${CLASS_NAME}`}>
        <div className={`${CLASS_NAME}__wrapper`}>

          <div className={`${CLASS_NAME}__box`}>
            {/* <img
              src="https://amplication.com/assets/react-admin.png"
              alt="React-Admin"
            /> */}
            <h2 style={{ fontFamily: 'IranSans-Bold' }}>پنل ادمین لیمومی‌شاپ</h2>
            <div className={`${CLASS_NAME}__box__message`}>
              برای ورود لطفا نام کاربری و پسورد خود را وارد کنید.
            </div>
            <form>
              <label>
                <span style={{ textAlign: 'right', fontFamily: 'IranSans-Light' }}>نام کاربری</span>

                <input
                  style={{ fontFamily: 'IranSans-Light' }}
                  name="username"
                  type="textbox"
                  value={username}
                  dir="ltr"
                  onChange={(e) => setUsername(e.target.value)}
                />
              </label>

              <label>
                <span style={{ textAlign: 'right', fontFamily: 'IranSans-Light' }}>رمز عبور</span>

                <input
                  name="password"
                  type="password"
                  value={password}
                  dir="ltr"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </label>

              <Button onClick={submit} variant="contained" color="primary">
                ورود
              </Button>

            </form>
          </div>


          <Notification />
        </div>
        {/* <div className={`${CLASS_NAME}__read-more`}>
          <span>Read </span>
          <a href="https://docs.amplication.com/docs/api" target="docs">
            Amplication docs
          </a>
          <span> to learn more</span>
        </div> */}
      </div>
    </ThemeProvider>
  );
};

export default Login;
